import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-dividing-line',
  templateUrl: './bmcore-dividing-line.component.html',
  styleUrls: ['./bmcore-dividing-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreDividingLineComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
